import { fetchProviderProducts } from "@/api/providerDashboard";

export default {
  name: "StoreProductPicker",
  data() {
    return {
      search: "",
      appliedSearch: "",
      products: [],
      page: 1,
      pageSize: 12,
      total: 0,
      loading: false,
      error: "",
      requestId: 0,
    };
  },
  created() {
    this.loadProducts(1);
  },
  beforeDestroy() {
    this.requestId += 1;
  },
  methods: {
    productImage(product) {
      return (
        (product.imagesUrls || []).find(
          (image) => typeof image === "string" && image.trim()
        ) || ""
      );
    },
    searchProducts() {
      this.appliedSearch = this.search.trim();
      return this.loadProducts(1);
    },
    async loadProducts(page) {
      const requestId = ++this.requestId;
      this.page = page;
      this.loading = true;
      this.error = "";
      this.products = [];
      this.total = 0;
      try {
        const response = await fetchProviderProducts({
          page,
          limit: this.pageSize,
          search: this.appliedSearch,
        });
        if (requestId !== this.requestId) return;
        if (response.data.status !== 200) throw new Error("product-list");
        this.products = response.data.data || [];
        this.total = response.data.total || 0;
      } catch (error) {
        if (requestId !== this.requestId) return;
        this.error = "매장 상품을 불러오지 못했습니다. 다시 시도해주세요.";
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
    selectProduct(product) {
      if (!this.loading && this.productImage(product)) {
        this.$emit("select", product);
      }
    },
  },
};
